/* Public voice-note page: /voice-gift/:token — no login needed. */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { TOK, SERIF, SANS, Orb, NAVY_BG } from "./SignatureBits";

const API = process.env.REACT_APP_BACKEND_URL;
const ORB = "radial-gradient(circle at 50% 50%, #fff1c9 0%, rgba(215,187,122,0.8) 22%, rgba(215,187,122,0.2) 48%, rgba(13,31,58,0) 68%)";

export default function VoiceGiftPage() {
  const { token } = useParams();
  const [g, setG] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    fetch(`${API}/api/voice-gifts/${token}`)
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then(setG)
      .catch(() => setMissing(true));
  }, [token]);

  return (
    <div className="min-h-screen relative overflow-hidden flex items-center" style={{ background: NAVY_BG, color: TOK.cream, fontFamily: SANS }} data-testid="voice-gift-page">
      <Orb gradient={ORB} size={360} className="absolute left-1/2 -translate-x-1/2 -top-32" style={{ opacity: 0.6 }} />
      <div className="relative w-full max-w-lg mx-auto px-6 py-24 text-center">
        {!g && !missing && <Loader2 className="animate-spin mx-auto" color={TOK.gold} />}
        {missing && <p className="italic text-lg" style={{ fontFamily: SERIF, color: TOK.creamDim }} data-testid="voice-gift-missing">This voice note isn&apos;t available.</p>}
        {missing && <a href="/soulumo" className="inline-block mt-8 text-[0.65rem] uppercase tracking-[0.3em] underline" style={{ color: TOK.gold }} data-testid="voice-gift-home-link">Go to Soulumo</a>}
        {g && (
          <div className="sig-rise">
            <div className="text-[0.6rem] uppercase tracking-[0.34em] mb-4" style={{ color: TOK.goldSoft }}>A voice note{g.to_name ? ` for ${g.to_name}` : ""}</div>
            <h1 className="text-4xl sm:text-5xl font-light leading-tight" style={{ fontFamily: SERIF, color: TOK.cream }} data-testid="voice-gift-from">
              From {g.from_name}
            </h1>
            <audio src={`${API}${g.audio_url}`} controls className="w-full mt-10" data-testid="voice-gift-audio" />
            <p className="mt-8 text-xl italic leading-relaxed" style={{ fontFamily: SERIF, color: TOK.creamDim }} data-testid="voice-gift-message-text">&ldquo;{g.message}&rdquo;</p>
            <a href="/soulumo" className="inline-block mt-14 text-[0.6rem] uppercase tracking-[0.3em]" style={{ color: TOK.creamMist }} data-testid="voice-gift-soulumo-link">
              Made with SOULUMO
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
